/**
 * Defined if a user can manage a risk based on his rights or role
 * @param {*} userConnected
 * @param {*} risk - S or P
 * @returns boolean
 */
export const hasRiskRight = (userConnected, risk) => {
    if (userConnected.role === 'ADMIN') return true;
    if (userConnected.perimetre.risques.includes(risk)) return true;
    return false;
};

/**
 * Defined if a user can manage a role based on his rights or role
 * @param {*} userConnected
 * @param {*} role
 * @returns
 */
export const hasRoleRight = (userConnected, role) => {
    if (!userConnected) return false;
    if (userConnected.role === 'ADMIN') return true;
    if (userConnected.roles.includes(role)) return true;
    return false;
};
